var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-notification',{attrs:{"add":_vm.toAdd,"remove":_vm.toRemove},on:{"undo":_vm.revertAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }